/**
 * How many leading chips fit on one line. Pure so it can be tested — jsdom reports
 * every width as 0, so a component that measures and decides in the same place
 * cannot be tested at all.
 *
 * Always keeps at least one: a row that hides everything reads as broken, and a
 * popover measured before it opens reports zero width.
 */
export function fitChips(widths: number[], available: number, gap: number): number {
    if (widths.length === 0) return 0;
    let used = 0;
    let count = 0;
    for (const width of widths) {
        const next = used + width + (count > 0 ? gap : 0);
        if (next > available && count > 0) break;
        used = next;
        count += 1;
    }
    return Math.max(1, count);
}
